<div class="container-fluid">
  
  <div class="card">
    <div class="card-body">

      <h4 class="card-title mb-4 text-muted"><i class="fa fa-cogs fa-2x mr-3" aria-hidden="true"></i>Cursus</h4>

      <ul class="list-group list-group-flush">
        <li class="list-group-item" *ngFor="let cycle of cyclesList; let i = index">

          <div class="card-text">
            <h6><a class="card-title text-info" data-toggle="collapse" href="#collapseCycle{{i}}"><label>{{cycle.ValueDOS}}</label></a></h6>

            <div id="collapseCycle{{i}}" class="panel-collapse collapse">

              <div class="row">
                <div class="col-md-6">
                  <table class="table table-striped table-hover table-condensed table-bordered">
                    <tbody>
                      <tr><td class="td1">AnDebDOS</td><td class="td2">{{cycle.AnDebDOS}}</td></tr>
                      <tr><td class="td1">Body_DOS</td><td class="td2">{{cycle.Body_DOS}}</td></tr>
                      <tr><td class="td1">CoStaDOS</td><td class="td2">{{cycle.CoStaDOS}}</td></tr>
                      <tr><td class="td1">DateDDos</td><td class="td2"><strong>{{cycle.DateDDos}}</strong></td></tr>
                      <tr><td class="td1">DateFDOS</td><td class="td2"><strong>{{cycle.DateFDOS}}</strong></td></tr>
                      <tr><td class="td1">Etat_DOS</td><td class="td2">{{cycle.Etat_DOS}}</td></tr>
                      <tr><td class="td1">NModuDOS</td><td class="td2">{{cycle.NModuDOS}}</td></tr>
                    </tbody>
                  </table>
                </div>

                <div class="col-md-6">
                  <table class="table table-striped table-hover table-condensed table-bordered">
                    <tbody>
                      <tr><td class="td1">NbHeuDOS</td><td class="td2">{{cycle.NbHeuDOS}}</td></tr>
                      <tr><td class="td1">NbJouDOS</td><td class="td2">{{cycle.NbJouDOS}}</td></tr>
                      <tr><td class="td1">NuModDOS</td><td class="td2">{{cycle.NuModDOS}}</td></tr>
                      <tr><td class="td1">NucasDOS</td><td class="td2">{{cycle.NucasDOS}}</td></tr>
                      <tr><td class="td1">PjextDOS</td><td class="td2">{{cycle.PjextDOS}}</td></tr>
                      <tr><td class="td1">PriCyDOS</td><td class="td2">{{cycle.PriCyDOS}}</td></tr>
                      <tr><td class="td1">User_DOS</td><td class="td2" style="color:#ff0000;"><strong>{{cycle.User_DOS}}</strong></td></tr>
                    </tbody>
                  </table>
                </div>
              </div>


              <h6><a class="card-title text-warning" data-toggle="collapse" href="#collapse{{i}}"><label>{{'internofcycle'|localize}}</label></a></h6>

              <div class="panel-collapse collapse" id="collapse{{i}}">
                <div class="row">
                  <div class="col-md-12">
                    <table class="table table-striped table-hover table-condensed table-bordered">
                      <tbody>
                        <tr *ngFor="let stage of cycle.StageCycle">
                          <td>{{stage.Info_PRO}}</td>
                          <td>{{stage.datedPRO}}</td>
                          <td>{{stage.datefPRO}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </li>
        
      </ul>

    </div>
  </div>
</div>
